import { AttachButton } from './getAttachmentCommandItems';
import { logUsage } from 'owa-analytics';
import ItemId from 'owa-service/lib/contract/ItemId';
import getAttachMenuData from './getAttachMenuData';

export default function logAttachMenuData(
    referenceItemId: ItemId,
    defaultButtonsList: AttachButton[]
) {
    const menuData = getAttachMenuData(referenceItemId);

    // Log data now.
    // This datapoint is used in OWA intelligence scorecard.
    // Make sure any change won't break the scorecard
    logUsage('AttachButtonMenuOpened', [
        ...menuData,
        defaultButtonsList.join(','),
        true /* isMail */,
    ]);
}
